
























































































import Vue from 'vue';

export default Vue.extend({
  props: {
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    cobrosDialog: false,
    loading: false,
    // conceptos: [],
    nuevoItem: {},
    // conceptosFiltro: [],
    filtro: {},
    headers: [
      { text: 'Propietario', value: 'propietario.nombre' },
      // { text: 'Recibo Id', value: 'id' },
      { text: 'Serie', value: 'serie' },
      { text: 'Folio', value: 'folio' },
      { text: 'Administración', value: 'administracion.shortName' },
      { text: 'Condominio', value: 'condominio.nombre' },
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Total', value: 'openTotal'},
    ],
    recibosTabla: [],
    selectedItems: [],
    recibo: [],
    precision: 2,
    // selectedConcepto: '',
    cobro: {
      monto: '',
      fecha: '',
      referencia: '',
      metodoDePago: '',
      cuenta: {},
    },
    cobros: ['Efectivo', 'Cheque', 'Transferencia'],
    menu: false,
    dateCobro: '',
    formatoFecha: 'DD/MM/YYYY',
    cuentasBancarias: [],
    options: {page: 1, itemsPerPage: 100000, sortBy: 0},
  }),
  mounted() {
    // this.dateCobro = this.$moment().format();
  },
  computed: {
    computedDateFormatted() {
      if (this.dateCobro === '') {
        return this.dateCobro;
      } else {
        return  this.$moment(this.dateCobro).format(this.formatoFecha);
      }
    },
  },
  methods: {
    async loadData() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const result = await this.$store.dispatch('getCuentasList', {admin, condo, options: this.options});
      this.cuentasBancarias = result.content;
      // console.debug('CuentasResult %o', this.cuentasBancarias);
    },
    async newCobro() {
      this.cobro.fecha = this.$moment(this.dateCobro).format();
      if (this.cobro.monto && this.cobro.fecha && this.cobro.metodoDePago && this.cobro.cuenta) {
        if (this.recibo[0].openTotal >= this.cobro.monto) {
          console.log('OpenTotal: %o', this.recibo[0].openTotal);
          try {
            const admin = this.$store.getters.getAdmin;
            const condo = this.$store.getters.getCondo;
            const recibo = this.recibo[0];
            const cobro = this.cobro;
            const datos = {admin, condo, recibo, cobro};
            console.debug('addCobro enviado %o', datos);
            const response = await this.$store.dispatch('addCobro', {datos});
            console.debug('addCobro response: %o', response);
            this.$toast.success('Cobro agregado exitosamente');
            this.closeDialog();
          } catch (e) {
            console.error(e);
          }
        } else {
          this.$toast.error('Monto maximo aceptado: $' + this.recibo[0].openTotal);
        }
      } else {
        this.$toast.error('Campos vacios');
      }
    },
    closeDialog() {
      this.cobro = {monto: '', fecha: '', referencia: '', metodoDePago: '', cuenta: {}};
      this.dateCobro = '';
      this.$emit('reload', {});
      this.cobrosDialog = false;
    },
    modeloReciboTabla() {
      return {
        key: '',
        id: 0,
        administracion: {},
        condominio: {},
        propietario: {},
        unidad: {},
        item: {},
      };
    },
    modeloNuevoItem() {
      return {
        concepto: {},
        descripcion: '',
        unidadDeMedida: '',
        cantidad: '',
        unitario: '',
        importe: 0,
      };
    },
    restrictChars($event, e) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode)) || ($event.charCode === 46) && (e.indexOf('.') === -1))   {
        return true;
      } else {
        $event.preventDefault();
      }
    },
  },
  watch: {
    cobrosDialog() {
      if (this.cobrosDialog) {
        this.recibo = this.recibosInit;
        // console.log('recibos %o', this.recibos);
        this.total = this.recibo.length;
        this.loadData();
      } else {
        this.recibo = [];
      }
    },
  },
});
